import 'styles/templates/brands.scss'

import Vue from 'vue'
import Brands from 'scripts/vue/templates/Brands'

window.PSTheme.Vue.Brands = new Vue({
  name: 'Brands',
  components: { Brands }
}).$mount('.brands')